<form [formGroup]="residentialAddressForm">
  <div class="step-container">
    <!-- <div class="step-title">{{ getTranslation('emergencyContact.title') }}</div> -->

    <div *ngIf="isJsonShow">
      {{residentialAddressForm.value | json}}
    </div>



    <div class="row gx-2">
      <div class="form-group col-12 col-md-4 mb-3">
        <label for="inputEmergencyName" class="form-label">{{ getTranslation('emergencyContact.contactName') }} <span
            class="text-danger">*</span></label>
        <input type="text" class="form-control" id="inputEmergencyName" formControlName="EMERGENCYContactName"
          [placeholder]="getTranslation('emergencyContact.enterContactName')" maxlength=50>
        <div *ngIf="submitted && residentialAddressForm.controls['EMERGENCYContactName'].invalid" class="text-danger">
          {{ getTranslation('validation.contactNameRequired') }}
        </div>
      </div>




      <div class="form-group col-12 col-md-4 mb-3">
        <label for="inputEmergencyRelationship" class="form-label"> {{ getTranslation('emergencyContact.relationship') }} <span
            class="text-danger">*</span> </label>
        <select class="form-control" id="inputEmergencyRelationship" formControlName="EMERGENCYContacRelationship">
          <option value="" disabled selected>{{ getTranslation('emergencyContact.selectRelationship') }}</option>
          <option *ngFor="let option of relationshipOptions" [value]="option.id"> {{ option.name }} </option>
        </select>
        <div *ngIf="submitted && residentialAddressForm.controls['EMERGENCYContacRelationship'].invalid"
          class="text-danger"> {{ getTranslation('validation.relationshipRequired') }} </div>
      </div>



      <div class="form-group col-12 col-md-4 mb-3">
        <label for="inputEmergencyMobile" class="form-label">{{ getTranslation('address.mobilePersonal') }}: <span
            class="text-danger">*</span></label>
        <div class="d-flex">
          <div class="country-code-container">
            <ng-select
              formControlName="CountryCode"
              [items]="countryCodeOptions"
              bindLabel="code"
              bindValue="code"
              [searchable]="true"
              [searchFn]="searchCountry"
              [clearable]="false"
              [placeholder]="getTranslation('address.selectCountry')"
              (change)="onCountryCodeChange($event)">
              <ng-template ng-option-tmp let-item="item">
                {{ item.code }} ({{ item.country }})
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                {{ item.code }} ({{ item.country }})
              </ng-template>
            </ng-select>
          </div>
          <input type="text" class="form-control mobile-number-input" id="inputEmergencyMobile" formControlName="Mobile"
            [placeholder]="getTranslation('emergencyContact.enterEmergencyMobile')" maxlength="15"
            (keypress)="genericValidations.onlyNumberWithoutPointValidator($event)">
        </div>
        <div *ngIf="submitted && residentialAddressForm.controls['CountryCode'].invalid" class="text-danger">
          <span *ngIf="residentialAddressForm.controls['CountryCode'].errors?.['required']">{{ getTranslation('validation.countryCodeRequired') }}</span>
        </div>
        <div *ngIf="(submitted || residentialAddressForm.controls['Mobile'].touched) && residentialAddressForm.controls['Mobile'].invalid" class="text-danger">
          <span *ngIf="residentialAddressForm.controls['Mobile'].errors?.['required']">{{ getTranslation('validation.mobileRequired') }}</span>
          <span *ngIf="residentialAddressForm.controls['Mobile'].errors?.['pattern']">{{ getTranslation('validation.mobileInvalid') }}</span>
          <span *ngIf="residentialAddressForm.controls['Mobile'].errors?.['maxlength']">{{ getTranslation('validation.mobileMaxLength') }}</span>
          <span *ngIf="residentialAddressForm.controls['Mobile'].errors?.['sameAsCurrentMobile']">
            {{ getTranslation('validation.mobileMustDiffer') || 'Emergency contact number must differ from current address number.' }}
          </span>
        </div>
      </div>

  

      <div class="form-group col-12 col-md-4 mb-3">
        <label for="inputEmergencyWorkPhone" class="form-label">{{ getTranslation('address.mobileAlternate') }}:</label>
        <input type="text" class="form-control" id="inputEmergencyWorkPhone" formControlName="WorkPhone"
          [placeholder]="getTranslation('emergencyContact.enterWorkPhone')" maxlength="10"
          (keypress)="genericValidations.onlyNumberWithoutPointValidator($event)">
      </div>



      <div class="form-group col-12 col-md-4 mb-3">
        <label for="inputEmergencyEmail" class="form-label">{{ getTranslation('address.email') }}:</label>
        <input type="email" class="form-control" id="inputEmergencyEmail" formControlName="Email"
          [placeholder]="getTranslation('emergencyContact.enterEmergencyEmail')" maxlength="50">
        <!-- <div *ngIf="submitted && residentialAddressForm.controls['Email'].invalid" class="text-danger">
        Valid Emergency Email is required.
    </div> -->
      </div>

    </div>

  </div>
  <!-- Buttons -->
  <!-- Buttons start -->
  <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" *ngIf="!isPreviewMode">
    <button type="button" style="display: none;" class="btn savedraftbtn" 
            *ngIf="residentialAddressForm.get('SaveMode')?.value !== SaveMode.SAVE"
            (click)="onSubmit(SaveMode.DRAFT,'CHILD')">
      <i class="fas fa-save mr-2"></i>SAVE AS DRAFT
    </button>
 
    <!-- <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE,'CHILD')">
      <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
    </button> -->
  </div>
  <!-- Buttons ends -->
</form>